import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['UserManager']['getProfileWithKyc']
type inputType = RouterInputs['UserManager']['getProfileWithKyc']

export const useGetProfileWithKyc = (input: inputType, options?: optionsType) =>
    api.UserManager.getProfileWithKyc.useQuery(input, {
        queryKey: ['UserManager.getProfileWithKyc', input],
        staleTime: 60 * 10 * 1000 * staleTimeIndex, // 1 hour
        refetchOnWindowFocus: true,
        ...options
    })
